import tamiaPic from "@/public/images/artists/tamia.png";
import { Artist } from "@/types/types";

export const tamia = {
  id: "220",
  name: "Tamia",
  image: tamiaPic,
  description: `Tamia's voice is punchy and dynamic, with a confident, vibrant tone. Her delivery flows effortlessly between sharp, rhythmic verses and catchy, melodic hooks, combining attitude with natural charisma.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ftamia-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Hip Hop", "Unprocessed"],
      secondary: ["Rap"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 53,
        high: 69,
      },
      sweetSpot: 59,
    },
  },
} as const satisfies Artist;
